export default
[
	{
		"no": 1,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "トップページ",
		"scene_image": "howto_1",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "ジオグラフでは、わたしたちのまちの様子を３次元グラフで「見える化」させた地図が操作できるんだ。まずは、画面の上の方にある【ジオグラフをはじめる】をタップしよう。",
		"注記": "漢字は小6までの学習漢字は用いました。"
	},
	{
		"no": 2,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "テーマ選択画面\n第１階層",
		"scene_image": "howto_2",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "色んな切り口が選べるのね。私は中学生だけど、【高校地理総合】ものぞいてみたいし、【SDGs】も気になるわ。",
		"注記": ""
	},
	{
		"no": 3,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "地図画面_11-04_モード①\n（初回表示ウィンドウ）",
		"scene_image": "howto_3",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "わわっ！気になるテーマを選んだら、地図が出てきた！とにかくボタンを押してみてだって！ゲームみたいで面白そう！",
		"注記": ""
	},
	{
		"no": 4,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "地図画面_11-04_モード①",
		"scene_image": "howto_4",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "ねぇねぇ、私たちの住んでいるまちを見てみようよ。画面の上の方に、おじいちゃんの家があるまちが書いてあるから、ここをタップしちゃえ！",
		"注記": ""
	},
	{
		"no": 5,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "都道府県選択ウィンドウ",
		"scene_image": "howto_5",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "みんな、日本の都道府県は頭に入ってる？分からなかったら、地図帳に戻って確かめることね。",
		"注記": ""
	},
	{
		"no": 6,
		"komidashi": "１．ジオグラフをはじめよう",
		"scene": "市町村選択ウィンドウ",
		"scene_image": "howto_6",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "下の方へスクロールすると、地図からではなく、都道府県の名前からも選べるよ。そのあとは、見たい市町村をその名前から選ぼう。",
		"注記": "【全体】および【東京23区】はボタンの色を変えておきたいです。"
	},
	{
		"no": 7,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "地図画面_11-04_モード①",
		"scene_image": "howto_7",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "すごーい！私たちが住んでいるまちが出てきたよ～　カラフルな柱？がでこぼこ立ってるねぇ",
		"注記": ""
	},
	{
		"no": 8,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "凡例_11-04",
		"scene_image": "howto_8",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "そうだね。地図を見るときは【凡例】を見るのが基本なんだ。柱の高さやカラフルな色の意味も、ここで分かるんだよ。ふむふむ、〈高さ〉は人口の多さを、〈色〉は電車の駅やバス停への近さを表しているようだね。",
		"注記": ""
	},
	{
		"no": 9,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "",
		"scene_image": "howto_8",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "それから…右下のパネルの中の「1人:1m」の書き方、どこかで見たことないかい？ほら、真ん中の「：」をはさんで、両側に数字がある…",
		"注記": ""
	},
	{
		"no": 10,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "",
		"scene_image": "howto_8",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "それ、地図帳の縮尺よね。1人あたり1mの高さの柱、3000人なら3㎞の高さで柱を描いているということだわ。このパネルを押すとどうなるのよ？",
		"注記": ""
	},
	{
		"no": 11,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "高さ設定ウィンドウ",
		"scene_image": "howto_9",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "おりゃっ！５倍！わわわ、にょきにょきだぁー！",
		"注記": ""
	},
	{
		"no": 12,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "地図画面_11-04_モード①\n＊高さ5倍",
		"scene_image": "howto_10",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "あら、ボタンの中の数字が「1人:1m×５」に変わっているじゃない。芸が細かいわね。",
		"注記": ""
	},
	{
		"no": 13,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "凡例_11-04",
		"scene_image": "howto_11",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "まじめな私は、右上の「データ詳細」ボタンが気になるわぁ～　調べたことは、それがきちんと根拠をもった情報なのか確かめないといけない、って習ったもの。",
		"注記": ""
	},
	{
		"no": 14,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "データ詳細ウィンドウ",
		"scene_image": "howto_12",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "そうなんだよ。ここでは、高さや色の意味をよりていねいに説明しているし、もともとどこで調査されたものなのか、【出典】も示しているんだよ。文字が青いところは、出典元のページへのリンクになっているね。",
		"注記": ""
	},
	{
		"no": 15,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "",
		"scene_image": "howto_12",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "ここだけの話、青字の「KMLダウンロード」を押すと、ジオグラフのデータを他のデジタル地図ソフトでも使えるファイルがダウンロードできるんだ。これは難しい操作になるので、先生向けの機能と思っておいてね。",
		"注記": ""
	},
	{
		"no": 16,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "凡例_11-04",
		"scene_image": "howto_13",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "はーい。まじめな私は、凡例の下にある「TRY」を読んで、まちの様子を読み解いていくヒントにするの。",
		"注記": ""
	},
	{
		"no": 17,
		"komidashi": "２．ジオグラフの凡例",
		"scene": "",
		"scene_image": "howto_13",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "ちなみに、「▼TRY」の文字のところをタップすると、TRYの文章が折り畳まれて、地図が見える範囲を広げることができるよ。「▼凡例」や「▼解説」も同じように、タップすることで折り畳みができるからね。",
		"注記": ""
	},
	{
		"no": 18,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①",
		"scene_image": "howto_7",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "ジオグラフに立ってる柱って、ぜんぶ真四角だよねー",
		"注記": ""
	},
	{
		"no": 19,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_7",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "うん。これは国が定めた区画（メッシュ）に則っているんだよ。ジオグラフでは、基本的には1辺の長さが約1㎞の「三次メッシュ」が使われているんだ。日本全体を表示するときには、1辺の長さが約10㎞の「二次メッシュ」が使われているよ。",
		"注記": ""
	},
	{
		"no": 20,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_7",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "すごいな、国の公式な規格なんだ！もう、ただの柱じゃないね。ぼくはこれを【３次元グラフ】と呼ぶことにするよ！",
		"注記": ""
	},
	{
		"no": 21,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_7",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "ねぇねぇ。最初に私たちの住んでいるまちを選んだパネルの下にある、3つのパネルが気になるの～。時計と地球と回転？何かしら？",
		"注記": ""
	},
	{
		"no": 22,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①\n＊年次：1995",
		"scene_image": "howto_14",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "時計のパネルを押したら、4ケタの数字が2015から1995に変わったわ。同時に３次元グラフの高さも多くが縮んだ。これはグラフが示す〈年次〉を表しているのね。1995年って、パパが中学生のころだわ。",
		"注記": ""
	},
	{
		"no": 23,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①\n＊背景：地図１",
		"scene_image": "howto_15",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "私は、真ん中の地球のマーク。あっ、背景が変わった！〈地図２〉にすると、私たちのまちの境界線も分かりやすくて、調べたことをまとめるときに便利かも～",
		"注記": ""
	},
	{
		"no": 24,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①\n＊回転後：北から視点",
		"scene_image": "howto_16",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "ぼくは、このぐるぐるボタン！ぼくが命名した３次元グラフ、こっちの角度から見るともっとかっこいいよ。って、へぇー、北から見たら、グラフにこんなへこんだ場所があったんだ～",
		"注記": ""
	},
	{
		"no": 25,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_16",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "画面を指で直接さわっても、視点の移動や、ズームイン・ズームアウトができるねぇ。これってスマホや学校で配られたタブレットの操作と同じだね。",
		"注記": ""
	},
	{
		"no": 26,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_16",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "柱の天井をダブルタップなさい。すごいわよ。",
		"注記": ""
	},
	{
		"no": 27,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①\n＊3次元グラフ内部\n＊背景は写真",
		"scene_image": "howto_17",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "うおお！柱の内側に！！手品？！\n左上のウィンドウで示している数字は、この区画のデータってこと？！すごいや！そしてこのメッシュコードが、国が定めた公式の証なんだろうな～",
		"注記": ""
	},
	{
		"no": 28,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "地図画面_11-04_モード①\r\n＊3次元グラフ内部\r\n＊背景は写真",
		"scene_image": "howto_18",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "私の好きな〈地図２〉だと、ここの住所も分かっちゃうわぁ。「場所を確認する」パネルを押すと、グーグルの地図も呼び出せるみたい。",
		"注記": ""
	},
	{
		"no": 29,
		"komidashi": "３．ジオグラフの地図と３次元グラフ",
		"scene": "",
		"scene_image": "howto_18",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "楽しんだようね。３次元グラフではなく、地面が直接見えているところをダブルタップすれば、ある程度の高さから真北に向かってながめる、最初の視点にもどれるわ。",
		"注記": ""
	},
	{
		"no": 30,
		"komidashi": "４．ジオグラフの５つのモード",
		"scene": "地図画面_11-04_モード④",
		"scene_image": "howto_19",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "ジオグラフは、まだまだこんなものじゃないんです！画面の上の方に、カラフルな５色のタブがあるよね？黄緑の「事例とその解説」を押してみて。ここでは、選んだテーマの解説が読めるんだよ。",
		"注記": ""
	},
	{
		"no": 31,
		"komidashi": "４．ジオグラフの５つのモード",
		"scene": "地図画面_11-04_モード②\n＊左を1995年、右を2015年",
		"scene_image": "howto_20",
		"chara": "ハート",
		"chara_image": "chara_4",
		"dialogue": "オレンジの「地域の昔と比べる」だと、ママが中学生のころの時代と左右同時にながめられるんだねぇ。タブの下から左右にのびる帯も、オレンジになった～",
		"注記": ""
	},
	{
		"no": 32,
		"komidashi": "４．ジオグラフの５つのモード",
		"scene": "地図画面_11-04_モード③\n＊左を糸島市、右を雲仙市",
		"scene_image": "howto_21",
		"chara": "ダイヤ",
		"chara_image": "chara_3",
		"dialogue": "黄色の「他の地域と比べる」では、なんと、サッカーの天才の友達が転校していったまちと、左右で並べられたぞ！",
		"注記": ""
	},
	{
		"no": 33,
		"komidashi": "４．ジオグラフの５つのモード",
		"scene": "地図画面_11-01_モード⑤",
		"scene_image": "howto_22",
		"chara": "スペード",
		"chara_image": "chara_2",
		"dialogue": "ふふっ…水色の「広域で見る」からは、我が国全体の様子を高みからながめられるわね… そのうえ「日本全国」と書いてあるボタンを押すと、七地方区分でながめることも選べるわ。",
		"注記": ""
	},
	{
		"no": 34,
		"komidashi": "５．困ったときに",
		"scene": "地図画面_11-01_モード①",
		"scene_image": "howto_23",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "楽しんでくれたかい？最後に、困ったときにどうするか、伝えておくね。画面の右上の方に、4種類の黒地のボタンがあるよね。これは、左から順に【テーマ選択ページ】【使い方ページ（今見ているページ）】【FAQページ】【トップページ】に移れるんだ。",
		"注記": ""
	},
	{
		"no": 35,
		"komidashi": "５．困ったときに",
		"scene": "FAQ＞操作について",
		"scene_image": "howto_24",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "操作が分からなくなったときには、【FAQページ】ボタンを押して移ったページで「操作について」を選ぶと、よくある質問とそれへの答えが読めるんだ。",
		"注記": ""
	},
	{
		"no": 36,
		"komidashi": "５．さあ、ジオグラフを使ってみよう",
		"scene": "テーマ選択＞SDGsから選ぶ",
		"scene_image": "howto_25",
		"chara": "クラブ",
		"chara_image": "chara_1",
		"dialogue": "さあ、それでは、画面右上の黒地のボタンの左から一つ目のボタンを押せば、【テーマ選択ページ】に入れるよ。ジオグラフで、それぞれの地域のあり方を探究していこう！",
		"注記": ""
	}
]